import React from 'react'
import { LoadingOutlined } from '@ant-design/icons';
import { Spin as Sp } from 'antd';

export default function Spin(props) {
  return (
    <Sp {...props}
    indicator={
      <LoadingOutlined
        style={{
          fontSize: (props.style && props.style.fontSize)?props.style.fontSize:20,
        }}
        spin
      />
    }
  />
  )
}
